import React, { useState } from "react";
import { Form, Input, TextArea, Button } from "semantic-ui-react";
import Swal from "sweetalert2";
import { Container } from "react-bootstrap";
import { Translation } from "react-i18next";

const FORMSPREE_ENDPOINT = "https://formspree.io/f/mvgaalll";

const FormSubmission = () => {
  const [loading, setLoading] = useState(false);

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(e.target);

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Message Sent Successfully",
        });
        e.target.reset();
      } else {
        const data = await response.json();
        throw new Error(data?.error || "Unknown error");
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Ooops, something went wrong",
        text: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Translation>
      {(t) => (
        <Container
          style={{
            width: "100%",
            maxWidth: "35em",
            margin: "0 auto",
          }}
        >
          <h1
            className="home-title-big_portfolio"
            style={{
              fontFamily: "Montserrat, sans-serif",
              color: "#1c4280",
              fontSize: "2.1rem",
            }}
            id="Contact"
          >
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#46669c"
              style={{
                width: "1.3em",
                height: "1.3em",
              }}
            >
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            {t(["form.title"])}
          </h1>
          <div className="Form">
            <Form onSubmit={handleOnSubmit}>
              <Form.Field
                control={Input}
                label={t(["form.title-2"])}
                name="email"
                placeholder={t(["form.e-address"])}
                required
                icon="mail"
                iconPosition="left"
              />
              <Form.Field
                control={Input}
                label={t(["form.title-3"])}
                name="name"
                placeholder={t(["form.e-name"])}
                required
                icon="user circle"
                iconPosition="left"
              />
              <Form.Field
                control={TextArea}
                label={t(["form.title-4"])}
                name="message"
                placeholder={t(["form.e-message"])}
                required
              />
              <Button
                type="submit"
                loading={loading}
                disabled={loading}
                style={{
                  fontFamily: "Montserrat, sans-serif",
                  backgroundColor: "#46669c",
                  color: "#fff",
                  borderColor: "#1c4280",
                  borderRadius: "0",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#1c4280";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#46669c";
                }}
              >
                {t(["form.button-5"])}
              </Button>
            </Form>
          </div>
        </Container>
      )}
    </Translation>
  );
};

export default FormSubmission;
